/* eslint-disable */
import { ApiKeyType } from '../dto/api-key-type';

export interface ApiKeyCreateRequestDto {
  description: string;
  type: ApiKeyType;
  partnerId?: string | null;
  expires: Date;
}

export const fixApiKeyCreateRequestDtoFromJson = (dto?: ApiKeyCreateRequestDto | null): void => {
  if (!dto) {
    return;
  }
  dto.expires = dto.expires && new Date(dto.expires);
};

export const fixApiKeyCreateRequestDtoToJson = (dto?: ApiKeyCreateRequestDto | null): void => {
  if (!dto) {
    return;
  }
};
